// eslint-disable-next-line
import { React } from "react";
// import DesktopMenu from "./DesktopMenu";
// import Mobilemenu from "./Mobilemenu";
import Menu from "./Menu";
import MenuImage from "./MenuImage";

const MenuComponent = ({
  businessName,
  categories,
  grid_view,
  ItemTextColor,
  ItemPriceColor,
  websiteBackgroundColor,
  descriptionColor,
  categoryColor,
  menuImage = [],
  websiteTextColor,
  hide_menu_price,
}) => {
  return (
    <>
      <div>{/* <DesktopMenu /> */}</div>
      <div>{/* <Mobilemenu /> */}</div>
      <div style={{backgroundColor: websiteBackgroundColor}}>
        {menuImage.length > 0 ?
          (
            <MenuImage menuImage={menuImage}  />
          ) : (
            <Menu
              businessName={businessName}
              categories={categories}
              grid_view={grid_view}
              ItemTextColor={ItemTextColor}
              ItemPriceColor={ItemPriceColor}
              descriptionColor={descriptionColor}
              categoryColor={categoryColor}
              websiteTextColor={websiteTextColor}
              hideMenuPrice={hide_menu_price}
            />
          )
        }
      </div>
    </>
  );
};

export default MenuComponent;
